import React, { useEffect, useRef, useState } from "react";
import googleicon from '../../Assets/Images/googleicon.png';
import stripeicon from '../../Assets/Images/stripeImg.png';
import loginIcon from '../../Assets/Images/login_logo.png';
import razoricon from '../../Assets/Images/razorpay.png';
import { formatUSNumber, MakeAxiosRequest } from "../../utils/handler";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import OTPInput, { ResendOTP } from "otp-input-react";
import { useDispatch } from "react-redux";
import { login } from "../../features/authSlice";
import { isEmpty } from "lodash";
import { phoneRegex, swizzleUrl, bankAccountRegex, indianZipRegEx, convertToLowerCase, numberLetterRegExp } from "../../Constants";
import { emailRegEx } from "../../Constants";
import BackButton from "../../Components/Button/BackButton";
import WebViewModal from "../../Components/details/WebViewModal";
import { baseUrl } from "../../Constants";
import ReactFlagsSelect from "react-flags-select";
import { SwalError, SwalSuccess, SwalWarning } from "../../Components/SwalFns";
import ModalBox from "../../Components/modals/ModalBox";
import loaderFile from '../../Assets/Images/loader.gif';
import addImg from "../../Assets/Images/add-image.svg";
import ImageCropper from "../../Components/imageCrop/ImageCropper";
import { autoResize } from "../../utils/handler";
import PlacesAutocomplete, {
    geocodeByAddress,
    geocodeByPlaceId,
    getLatLng,
  } from "react-places-autocomplete";
import { Helmet } from "react-helmet";
function Login() {
    const AppName = process.env.REACT_APP_NAME;
    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [image, setImage] = useState();
    const [imgPath, setImgPath] = useState();
    const [hasImage, sethasImage] = useState(0);
    const [tempKey, setTempKey] = useState();
    const [fileCordinates, setFileCordinates] = useState();
    const [imageModalShow, setImageModalShow] = useState(false);

    const [showLoader, setShowLoader] = useState(false);
    const [isProfile, setIsProfile] = useState('profile');
    const [userKey, setUserKey] = useState('');
    const [orgKey, setOrgKey] = useState('');
    const [selected, setSelected] = useState("");
    const [options, setOptions] = useState("");
    const [taxData, setTaxData] = useState("");
    const [state, setStateData] = useState("");
    const [inState, setInStateData] = useState("");
    const [countryList, setCountryData] = useState("");
    const [BusinessList, setBusinessData] = useState("");
    const [categoryList, setCategoryData] = useState("");
    const [subCategoryList, setSubCategoryData] = useState("");
    const [isContinueDisabled, setContinueDisabled] = useState(false);
    const accesstoken = localStorage.getItem("accesstoken");
    const [isregister, setRegister] = useState("");
    const [razorUrl, setRazorUrl] = useState("");
    const [logintoken, setLoginToken] = useState("");
    const [otpvalues, setOtpvalues] = useState({
        otp_uuid: "",
        otp: "",
        phone_number: "",
        countrycode: "",
    });
    const [phonenumber, setPhoneNumber] = useState('');
    const [countrycode, setCode] = useState('');
    const [countryCode, setCountryCode] = useState('US');
    const [countryNumberCode, setNumberCountryCode] = useState('');
    const [companyshortcode, setCompanyShortCode] = useState('');
    const [companyphonenumber, setCompanyPhoneNumber] = useState('');
    const [companycountrycode, setCompanyCode] = useState('+1');
    const [shortcode, setShortCode] = useState('');
    const [OTP, setOTP] = useState("");
    const [url, setUrl] = useState("");
    const [otperror, setOtperror] = useState("");
    const [stripedata, setStripeData] = useState("");
    const [razorData, setRazorData] = useState("");
    const [country, setCountry] = useState("");
    const {
        register: registerForm1,
        handleSubmit: handleSubmit1,
        formState: { errors: errorsForm1 },
        watch: watch1,
        control: control1,
        setValue: setValue1,
        trigger: trigger1,
    } = useForm();

    const {
        register,
        handleSubmit,
        formState: { errors },
        setError,
        reset,
        watch,
        control,
        setValue,
        trigger,
        getValues,
    } = useForm();
    const zipPatterns = {
        IN: /^[1-9][0-9]{5}$/, // India
    };
    const [address, setAddress] = useState(getValues('address'));
  const fieldVal = watch('address');

  useEffect(() => {
    handleChange(fieldVal);
  }, [fieldVal])
  
  const onAddressChange = (addressComponents) => {
    console.log(addressComponents);
    // Update form fields individually using setValue
    for (const [key, value] of Object.entries(addressComponents)) {
      setValue(key, value);
      trigger(key);
    }
  };
    const getZipValidation = () => {
        const pattern = zipPatterns[country];
        return pattern
            ? {
                required: "Please enter zip code",
                pattern: {
                    value: pattern,
                    message: "Invalid zip code",
                },
            }
            : { required: "Please enter zip code" }; // Default if no pattern is found
    };

    const addImageRef = useRef(null);
    const openFile = () => {
      addImageRef.current.click();
    };
  
    function handleImgUpload(e) {
      if (e.target && e.target.files[0]) {

        console.log(e.target.files[0],'image upload');
        sethasImage(1);
        setImage(e.target.files[0]);
        setImageModalShow(true);
        
      }
    }
    const handleClose = () =>{
        sethasImage(0);
        setImageModalShow(false);
    }
    const croppedImage = (imgPath,tempKey,cordinates) => {
      setImage(null);
      setImgPath(imgPath);
      setImageModalShow(false);
      setFileCordinates(cordinates || null);
      trigger("image");
    };
  
    function removeImg() {
      setImage(null);
      setImgPath(null);
      sethasImage(0);
    }

    const handleOTPChange = (otp) => {
        setOTP(otp);
        if (otp.length === 4) {
            verifyOtp(otp);
        }
      };
    const getValidationRules = (fieldName) => {
        if (razorUrl) {
            // If `razorUrl` has a value, no validation for these fields
            return {};
        }

        // Define field-specific validation rules
        const rules = {
            first_name: { required: "Please enter first name" },
            last_name: { required: "Please enter last name" },
            email: {
                required: "Please enter email",
                pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Please enter a valid email address",
                },
            },
            company_name: { required: "Please enter company name / individual" },
            abbreviation:{ 
                required: "Please enter abbreviation",
                pattern: {
                    value: numberLetterRegExp,
                    message: "Please enter a valid abbreviation",
                },
                minLength: {
                    value: 2,
                    message: "Please enter a valid abbreviation",
                },
                maxLength: {
                    value: 5,
                    message: "Please enter a valid abbreviation",
                },
            },
            company_email: {
                required: "Please enter email",
                pattern: {
                    value: emailRegEx,
                    message: "Please enter a valid email address",
                },
            },
            company_phone_number: {
                required: "Please enter phone number",
                validate: (value) => {
                    const phoneNumber = value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                    return phoneNumber.length > 4 || 'Please enter a valid phone number';
                },
            },
            preferred_country: { required: "Please select country" },
            address: { required: "Please enter address" },
            city: { required: "Please enter city" },
            state: { required: "Please enter state" },
            state_id: { required: "Please select state" },
            zip: { required: "Please enter zip code" },
            currency_id: { required: "Please select currency" },
            tax_type: { required: "Please select tax type" },
        };

        return rules[fieldName] || {};
    };

    const handleCountryChange = (country, onChange) => {
        setSelected(country);
        setCountryCode(country);
        onChange(country);  // Update react-hook-form's state
        if (country === "IN") {
            setCountry("IN");
        } else if (country == "US") {
            setCountry("US");
        } else {
            setCountry(country);
        }
    };
    const email = watch("email");
    const checkEmailExist = async () => {
        try {
            const response = await MakeAxiosRequest("post", "/validateuser", { email: email });
            // console.log(response)
            if (response.status == 1) {
                setIsProfile('organization');
            } else {
                SwalWarning({ msg: response.message });
            }
        } catch (error) {
            console.error("Error", error);
        }
    }
    const submitNext = async () => {
        const result = await trigger(['first_name', 'last_name', 'email']);
        if (result) {
            checkEmailExist();
        }
    };
    const submitOrganizationNext = async () => {
        const result = await trigger(['company_name', 'comapany_email', 'company_phone_number', 'address', 'city', 'zip']);
        if (result) {
            setIsProfile('business');
        }
    };
    const submitBusinessNext = async () => {
        const result = await trigger(['business_name', 'business_type', 'category_id', 'sub_category_id']);
        if (result) {
            setIsProfile('stakeholder');
        }
    };
    const submitStakeholderNext = async () => {
        const result = await trigger(['stakeholder_name', 'stakeholder_email']);
        if (result) {
            setIsProfile('bank');
        }
    };
    const renderButton = (buttonProps) => {
        return (
            <button {...buttonProps} className="btn resend-btn" type="button">
                {buttonProps.remainingTime !== 0 ? `Resend OTP in ${buttonProps.remainingTime} sec` : "Resend OTP"}
            </button>
        );
    };
    const renderTime = () => React.Fragment;

    const categoryField = watch1("category_id");

    const fetchSubCategory = async (categoryID) => {
        try {
            const response = await MakeAxiosRequest("post", "/getcurrency", { categoryId: categoryID });
            // console.log(response)
            if (response) {
                const subCategoryData = response.data.subCategoryList?.map((item) => ({
                    value: item.slug,
                    name: item.category_name,
                }));
                setSubCategoryData(subCategoryData);
            } else {
                console.log(response);
            }
        } catch (error) {
            console.error("Error", error);
        }
    }
    useEffect(() => {
        if (categoryField) {
            // Find the selected category from the categoryList by matching the value
            const selectedOption = categoryList.find(option => option.value === categoryField);
            const categoryId = selectedOption ? selectedOption.id : null;

            if (categoryId) {
                fetchSubCategory(categoryId);
            }
        }
    }, [categoryField, categoryList]);
    useEffect(() => {
        if (!isEmpty(accesstoken) && accesstoken != "undefined") {
            // Redirect to dashboard page
            navigate("/dashboard");
        }
       
    }, []);
    useEffect(() => {
        fetchCurrencyData(countryCode);
    }, [countryCode]);
    useEffect(() => {
       
        fetchCurrencyData(shortcode);
    }, [shortcode]);
   

      useEffect(() => {

        if(taxData != ""){

            const selectedOption = taxData?.find((option) => option.is_selected === 1);
            if (selectedOption) {
            setValue("tax_type", selectedOption.value); // Update the form value
            }
        }
        
      }, [taxData, setValue]);
      useEffect(() => {

        if(options != ""){

            const selectedOption = options?.find((option) => option.is_selected === 1);
            if (selectedOption) {
            setValue("currency_id", selectedOption.value); // Update the form value
            }

        }
        
      }, [options, setValue]);

    const fetchCurrencyData = async () => {
        try {
            const response = await MakeAxiosRequest("post", "/getcurrency",{short_code:countryCode});
            // console.log(response)
            if (response) {

                const data = response.data.currencyData?.map((item) => ({
                    value: item.id,
                    name: item.currency,
                    symbol: item.currency_symbol,
                    is_selected: item.is_selected
                }));
                setOptions(data);
                const taxdata = response.data.taxdetails?.map((item) => ({
                    value: item.id,
                    name: item.tax_type,
                    is_selected: item.is_selected
                }));
                setTaxData(taxdata);
                const stateData = response.data.stateList?.map((item) => ({
                    value: item.id,
                    name: item.code,
                }));
                setStateData(stateData);
                const inStateData = response.data.indianstateList?.map((item) => ({
                    value: item.id,
                    name: item.state_name,
                }));
                setInStateData(inStateData);
                const countryData = response.data.countryList?.map((item) => ({
                    value: item.id,
                    name: item.country_name,
                }));
                setCountryData(countryData);
                const businessData = response.data.businessTypes?.map((item) => ({
                    value: item.slug,
                    name: item.business_types,

                }));
                setBusinessData(businessData);
                const categoryData = response.data.categoryList?.map((item) => ({
                    value: item.slug,
                    name: item.category_name,
                    id: item.id
                }));
                setCategoryData(categoryData);

            } else {
                console.log(response);
            }
        } catch (error) {
            console.error("Error", error);
        }
    }
    const fetchCountryData = async () => {
        try {
            const response = await MakeAxiosRequest("post", "/getcountry",{short_code:countryCode});
            // console.log(response)
            if (response) {

                const data = response.data.currencyData?.map((item) => ({
                    value: item.id,
                    name: item.currency,
                    symbol: item.currency_symbol
                }));
                setOptions(data);
                const taxdata = response.data.taxDetails?.map((item) => ({
                    value: item.id,
                    name: item.tax_type
                }));
                setTaxData(taxdata);
                const stateData = response.data.stateList?.map((item) => ({
                    value: item.id,
                    name: item.code,
                }));
                setStateData(stateData);

            } else {
                console.log(response);
            }
        } catch (error) {
            console.error("Error", error);
        }
    }
    const findStateId = (stateCode) => {
        if (!state) return null;
        const stateOption = state.find(option => 
          option.code?.toLowerCase() === stateCode?.toLowerCase() || 
          option.name?.toLowerCase().includes(stateCode?.toLowerCase())
        );
        return stateOption?.value || null;
      };
    
    const handleSelect = (address) => {
        setAddress(address);
        // console.log(address);
        geocodeByAddress(address)
          .then((results) => {
            const addressComponents = results[0].address_components;
    
            // Extract state, city, and zip code from the address components
            let addressArray = [];
            let city = "";
            let state = "";
            let zip = "";
            let postal_code = "";
            let modifiedAddress = address;
    
            for (const component of addressComponents) {
              const types = component.types;
              if (types.includes("street_number")) {
                addressArray.push(component.long_name); // Street number
              }
              if (types.includes("route")) {
                addressArray.push(component.long_name); // Route
              }
              // if (types.includes("neighborhood")) {
              //   addressArray.push(component.long_name); // Neighborhood
              // }
              if (types.includes("administrative_area_level_1")) {
                state = component.short_name; // State
                if (modifiedAddress.includes(component.short_name)) modifiedAddress = modifiedAddress.split(component.short_name)[0].trim();
                if (modifiedAddress.includes(component.long_name)) modifiedAddress = modifiedAddress.split(component.long_name)[0].trim();
              }
              if (types.includes("locality")) {
                city = component.long_name; // City
                if (modifiedAddress.includes(component.long_name)) modifiedAddress = modifiedAddress.split(component.long_name)[0].trim();
              }
              if (types.includes("postal_code")) {
                zip = postal_code = component.long_name; // Zip Code
              }
            }
    
            // Remove city, state, and zip code from the original address string
            for (const part of addressArray) {
              if (modifiedAddress.includes(part)) {
                modifiedAddress = modifiedAddress.split(part)[0].trim();
                break; // Stop after the first match
              }
            }
            // Join the remaining address parts with the modified address string
            const finalAddress = modifiedAddress!='' ? modifiedAddress +'\n'+ addressArray.join(", ") : addressArray.join(", ");
            const stateId = findStateId(state);

            const addressData = {
                address: finalAddress,
                modifiedAddress,
                city,
                state,
                zip,
                postal_code,
                state_id: stateId // Now using the mapped state ID instead of the state code
              };
      
              // First update the form values
              if (onAddressChange) {
                onAddressChange(addressData);
              }
            handleChange(finalAddress);
            // return getLatLng(results[0]);
          })
          // .then((latLng) => console.log("Success", latLng))
          .catch((error) => console.error("Error", error));
      };
    
      const handleChange = (value) => {
        setAddress(value);
        setValue('address', value);
        errors['address'] && trigger('address');
        getValidationRules('city');
        getValidationRules('state');
        getValidationRules('state_id');
        getValidationRules('zip');
        // console.log(value)
      }
    

    /* sentotp function */
    const sentOtp = async (formData) => {
        // fetchCurrencyData();
        setCountryCode(shortcode);
        setNumberCountryCode(shortcode);
        trigger('phone_number');
        setContinueDisabled(true);
        // formData.phone_number = extractNumbers(formData.phone_number);
        formData.phone_number = phonenumber;
        formData.country_code = countrycode;
        formData.short_code = shortcode;
        const res = await MakeAxiosRequest(
            "post",
            "/otp/generate",
            formData
        );
        setContinueDisabled(false);

        if (res.status == 1) {
            setOTP("");
            setRegister("otp");
            reset();
            setOtpvalues({
                ...otpvalues,
                phone_number: formData.phone_number,
                otp_uuid: res.data.otpKey,
                otp: res.data.otp,
                countrycode: formData.country_code,
                short_code: formData.short_code
            });
            if (process.env.REACT_APP_ENV != 'production') {

                alert(res.data.otp);
            }

        } else {
            setError("phone_number", { type: "custom", message: res.message });
            // alert(res.message);
        }
    };
    const resendOtp = async () => {
        const res = await MakeAxiosRequest("post", "otp/generate", {
            country_code: otpvalues.countrycode,
            phone_number: otpvalues.phone_number,
            short_code: otpvalues.short_code,
        });
        if (res.status == 1) {
            setOtpvalues({
                ...otpvalues,
                otp_uuid: res.data.otpKey,
            });
            if (process.env.REACT_APP_ENV != 'production') {

                alert(res.data.otp);
            }
        } else {
            alert(res.message);
        }
    };

    const verifyOtp = async (otp) => {
        
        if (otp.length != '4') {
            setOtperror('Please enter the OTP you have received');
        } else {
            const res = await MakeAxiosRequest("post", "otp/validate", {
                otp: otp,
                otp_uuid: otpvalues.otp_uuid,
                phone_number: otpvalues.phone_number,
                country_code: otpvalues.countrycode,
                shortCode: otpvalues.short_code
            });

            if (res.status == 1) {
                if (res.isregister != "1") {

                    localStorage.setItem("accesstoken", res.data.accesstoken);
                    localStorage.setItem(
                        "userName",
                        res.data.userDetails.first_name + " " + res.data.userDetails.last_name
                    );
                    localStorage.setItem("profileImage", res.data.userDetails.profile_image);
                    localStorage.setItem("email", res.data.userDetails.email);
                    localStorage.setItem("user", JSON.stringify(res.data));
                    
                    if (res.data.stripe_connected == '0') {
                        // getStripeInfo();
                        navigate('/stripeconnect');
                    } else if (res.data.is_razorpay_connected == '0') {
                        setRazorUrl('/createaccounts')
                        setRegister("register");
                        setIsProfile("business");
                    } else {

                        dispatch(login(res.data));
                        navigate("/dashboard");
                    }
                    //Dispatch the login action with user details

                } else {
                    setRegister("register");
                }
            } else {
                setOtperror(res.message);
                setOTP("");
            }
        }
    };

    const getRazorInfo = async () => {

        const res = await MakeAxiosRequest("post", "/getrazorpayconnection", {});
        if (res.status == 1) {
            setStripeData(res.data);
            setRegister("razorPay");
        }
    }

    const getStripeInfo = async () => {

        const res = await MakeAxiosRequest("post", "/stripe/getstripeconnectioninfo", {});
        if (res.status == 1) {
            setStripeData(res.data);
            const returnUrl = process.env.REACT_APP_STRIPE_URL;
            const responseurl = `${res.data.stripeURL}&redirect_uri=${returnUrl}`;
            setUrl(responseurl)
            setRegister("stripe");
        }
    }
    const registerSubmit = async (formData) => {
        formData.phone_number = phonenumber;
        formData.country_code = countrycode;
        formData.short_code = shortcode;
        formData.company_phone_number = companyphonenumber;
        formData.company_short_code = companyshortcode;
        formData.company_country_code = companycountrycode;
        formData.accesstoken = logintoken;
        formData.hasImage = hasImage;
        formData.filepath = tempKey;
        formData.istemp = hasImage;
        const res = await MakeAxiosRequest("post", '/register', { ...formData });
        if (res.status == 1) {

            localStorage.setItem("accesstoken", res.data.accesstoken);
            localStorage.setItem(
                "userName",
                res.data.userDetails.first_name + " " + res.data.userDetails.last_name
            );
            localStorage.setItem("profileImage", res.data.userDetails.profile_image);
            localStorage.setItem("user", JSON.stringify(res.data));
            dispatch(login(res.data));
            SwalSuccess({msg:res.message});
            if (res.data.stripe_connected == '0') {
                // getStripeInfo();
                navigate('/stripeconnect');
            } else if (res.data.is_razorpay_connected == '0') {
                getRazorInfo();
                // setIsProfile("business");
                setRazorUrl(res.data.razor_pay_url);
                setUserKey(res.data.userkey);
                setOrgKey(res.data.organization_uuid);
            } else {
                //   Dispatch the login action with user details
                dispatch(login(res.data));
                navigate("/dashboard");
            }

            // navigate("/dashboard");
        } else if (res.status == 0) {

            SwalWarning({ msg: res.message });
            setRegister("register");

        } else {
            alert(res.message);
        }
    };

    const razorPaySubmit = async (formData) => {
        setShowLoader(true);
        formData.userKey = userKey;
        formData.organization_key = orgKey;
        const res = await MakeAxiosRequest("post", '/createaccounts', { ...formData });
        if (res.status == 1) {
            setShowLoader(false);
            SwalSuccess({ msg: res.message });
            navigate("/dashboard");

        } else if (res.status == 0) {
            setShowLoader(false);
            SwalWarning({ msg: res.message });

        } else {
            setShowLoader(false);
            alert(res.message);
        }
    };

    const setBack = () => {

        if (isregister == 'otp') {
            setRegister("");
            setOTP("");
            setOtperror("");
        } else if (isregister == 'register') {

            if (isProfile == 'profile') {
                setRegister("");
            } else if (isProfile == 'business') {
                setIsProfile('organization');
            } else if (isProfile == 'stakeholder') {
                setIsProfile('business');
            } else if (isProfile == 'bank') {
                setIsProfile('stakeholder');
            } else {
                setIsProfile('profile');
            }
        }else if(isregister == 'razorPay'){

            setRegister('register');
            setIsProfile("organization");
        }

           
        
    }
      const handlesize = (e) => {
        autoResize(e.target);
      };
    return (
        <>
        <Helmet>
          <title>Login | {AppName}</title>
        </Helmet>

            <section className="login-pg">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-12 col-lg-6 p-0">
                            <div className="left-sec">
                                <div className="login-lft-sec">
                                    <img src={loginIcon} className="img-fluid  mb-3" alt="" />
                                    <div className="login-img-txt">
                                        <h3>Streamline Your Business Invoicing Effortlessly</h3>
                                        <div style={{ display: isregister == "" ? 'none' : 'block' }}>
                                            <BackButton
                                                btnFunction={setBack} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-12 col-sm-10 col-md-7 col-lg-9 col-xxl-8 mx-auto">
                                        {(() => {
                                            switch (isregister) {
                                                case "otp":
                                                    return (
                                                        <>
                                                            <div className="login-form">
                                                                <div className="loginText text-center">
                                                                    <h1>Verify OTP</h1>
                                                                    <p className="login m-0">OTP sent to {countrycode == '+1'
                                                                        ? countrycode + ' ' + formatUSNumber(phonenumber)
                                                                        : countrycode + ' ' + phonenumber} <a href="javacsript:void(0)" onClick={() => setRegister("")} className="ps-2">Change?</a></p>
                                                                </div>
                                                                <div className="loginInner text-center">
                                                                    <form onSubmit={handleSubmit((data) => verifyOtp(data))} onKeyDown={(e) => {
                                                                          if (e.key === "Enter") {
                                                                                e.preventDefault(); 
                                                                                handleSubmit(verifyOtp)(); 
                                                                            }
                                                                        }}>
                                                                        <div className="otpInner d-flex justify-content-between mx-4 pb-2">
                                                                            <label>Enter OTP Code</label>
                                                                        </div>
                                                                        <div className="otp-input mb-5 mx-4 position-relative">
                                                                            <OTPInput
                                                                                className="otp-input"
                                                                                inputClassName="form-control"
                                                                                value={OTP}
                                                                                onChange={handleOTPChange}
                                                                                secure={true}
                                                                                autoFocus
                                                                                OTPLength={4}
                                                                                otpType="number"
                                                                                disabled={false}

                                                                            />
                                                                            {otperror && (
                                                                                <span className="error">{otperror}</span>
                                                                            )}
                                                                        </div>

                                                                        <div className="submitBtnAlign">
                                                                            <button type="submit" className="btn btn-primary w-100">Submit OTP</button>
                                                                            <ResendOTP onResendClick={resendOtp} className="d-flex justify-content-center link" renderButton={renderButton} renderTime={renderTime} />
                                                                        </div>
                                                                    </form>
                                                                    {/* <div className="orSection">
                                                                        <span></span><p className="m-0">Having Troubles with OTP?</p><span></span>
                                                                    </div>

                                                                    <a href="" className="btn btn-outline-secondary w-100"><img src={googleicon} className="img-fluid" />Sign in with google</a> */}
                                                                </div>
                                                            </div>
                                                        </>
                                                    );
                                                case "register":
                                                    return (
                                                        <>
                                                            <div className="login-form" >
                                                                <div className="loginText text-center">
                                                                    <h1>Build Your Profile</h1>
                                                                    <p className="login m-0">Enter your profile details to get things started</p>
                                                                </div>
                                                                <div className="loginInner">
                                                                    <h1 className="text-center">
                                                                        {isProfile === 'profile'
                                                                            ? "Personal Details"
                                                                            : isProfile === 'business'
                                                                                ? "Business Details"
                                                                                : isProfile == 'stakeholder' ? "Stakeholder Details" : isProfile == 'bank' ? "Bank Account Details" : "Organization Details"}
                                                                    </h1>

                                                                    <form onSubmit={handleSubmit(registerSubmit)}>
                                                                        <div style={{ display: isProfile == 'profile' ? 'block' : 'none' }}>
                                                                            <div className="form-group floating-label mt-4">
                                                                                <input type="text" className="form-control" placeholder=""
                                                                                    {...register("first_name", getValidationRules('first_name'))} />
                                                                                <label for="">First Name</label>
                                                                                {errors.first_name && (
                                                                                    <span className="error">
                                                                                        {errors.first_name.message}
                                                                                    </span>
                                                                                )}
                                                                            </div>


                                                                            <div className="form-group floating-label mt-4">
                                                                                <input type="text" className="form-control" placeholder=""
                                                                                    {...register("last_name", getValidationRules('last_name'))} />
                                                                                <label for="">Last Name</label>
                                                                                {errors.last_name && (
                                                                                    <span className="error">
                                                                                        {errors.last_name.message}
                                                                                    </span>
                                                                                )}
                                                                            </div>


                                                                            <div className="form-group floating-label mt-4">
                                                                                <input type="text" className="form-control" placeholder=""
                                                                                    {...register("email", getValidationRules('email'))} />
                                                                                <label for="">Email</label>
                                                                                {errors.email && (
                                                                                    <span className="error">
                                                                                        {errors.email.message}
                                                                                    </span>
                                                                                )}
                                                                            </div>


                                                                            <button type="button" onClick={submitNext} className="btn btn-primary w-100">Next</button>
                                                                        </div>

                                                                        <div className="register" style={{ display: isProfile == 'organization' ? 'block' : 'none' }}>
                                                                            <div className="form-group floating-label mt-4">
                                                                                <input type="text" className="form-control" placeholder=""
                                                                                    {...register("company_name", getValidationRules('company_name'))} />
                                                                                <label for="">Company Name / Individual</label>
                                                                                {errors.company_name && (
                                                                                    <span className="error">
                                                                                        {errors.company_name.message}
                                                                                    </span>
                                                                                )}
                                                                            </div>

                                                                            <div className="form-group floating-label mt-2 mb-2 position-relative">


                                                                                <a className="tooltips" href="#"><span class="material-symbols-outlined">priority_high</span></a>
                                                                                <div class="tooltips-mag">Enter an abbreviation (2-5 characters) that will be used as the prefix in your invoice numbers. For example, if you choose XYZ, your invoices will be formatted as XYZ/INV/1001.</div>

                                                                                <input type="text" className="form-control pe-4" placeholder=""
                                                                                    {...register("abbreviation", getValidationRules('abbreviation'))} />
                                                                                <label for="">Abbreviation</label>
                                                                                {errors.abbreviation && (
                                                                                    <span className="error">
                                                                                        {errors.abbreviation.message}
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                            <div className="deets-form">
                                                                                <div className="row">
                                                                                    <div className="col-md-12">
                                                                                        <div className="form-group floating-label mt-2 mb-3">
                                                                                            <input type="text" className="form-control" placeholder=""
                                                                                                {...register("company_email", getValidationRules('company_email'))} />
                                                                                            <label for="">Email</label>
                                                                                            {errors.company_email && (
                                                                                                <span className="error">
                                                                                                    {errors.company_email.message}
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-md-6 mb-1">
                                                                                        <div className="form-group floating-label mt-4 mb-2">
                                                                                            <Controller
                                                                                                name="company_phone_number"
                                                                                                control={control}
                                                                                                rules={getValidationRules("company_phone_number")}
                                                                                                render={({ field: { onChange, value, ref, onBlur } }) => (
                                                                                                    <PhoneInput
                                                                                                        country={convertToLowerCase(countryNumberCode)}
                                                                                                        value={value}
                                                                                                        onlyCountries={['us', 'gb']} 
                                                                                                        onChange={(value, countryData) => {
                                                                                                            onChange(value);  // Update react-hook-form state
                                                                                                            const phoneNumberWithoutCountryCode = value.startsWith(countryData.dialCode)
                                                                                                                ? value.substring(countryData.dialCode.length)
                                                                                                                : value.replace(`+${countryData.dialCode}`, '');
                                                                                                            setCompanyPhoneNumber(phoneNumberWithoutCountryCode.trim());
                                                                                                            setCompanyCode(`+${countryData.dialCode}`);
                                                                                                            setCompanyShortCode(countryData.countryCode.toUpperCase());
                                                                                                        }}
                                                                                                        onBlur={() => {
                                                                                                            setValue('company_phone_number', value, { shouldValidate: true });
                                                                                                            onBlur();  // Trigger validation on blur (when the user leaves the field)
                                                                                                        }}
                                                                                                        enableSearch={true}
                                                                                                        searchPlaceholder="Search"
                                                                                                        containerClass="phone-code-form"
                                                                                                        countryCodeEditable={false}
                                                                                                        specialLabel="Phone Number"
                                                                                                        inputRef={ref}  // Attach ref to the input
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {errors.company_phone_number && (
                                                                                                <span className="error">
                                                                                                    {errors.company_phone_number.message}
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-md-6 mb-1">
                                                                                        <label for="" className="form-label primary_label m-0">Country</label>
                                                                                        <Controller
                                                                                            name="preferred_country"
                                                                                            control={control}
                                                                                            defaultValue={countryCode}
                                                                                            rules={getValidationRules("preferred_country")}
                                                                                            render={({ field, fieldState: { error } }) => (
                                                                                                <div className="form-group country mb-2">
                                                                                                    <ReactFlagsSelect
                                                                                                    selected={field.value || countryCode} 
                                                                                                        onSelect={(code) => handleCountryChange(code, field.onChange)}
                                                                                                        searchable={false}
                                                                                                        countries={['US', 'GB']}
                                                                                                        className="country-select"
                                                                                                    />
                                                                                                    {error && (
                                                                                                        <span className="error">
                                                                                                            {error.message}
                                                                                                        </span>
                                                                                                    )}
                                                                                                </div>
                                                                                            )}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>






                                                                            <div className="form-group floating-label mt-3 mb-3">
                                                                            <PlacesAutocomplete
                                                                                value={address}
                                                                                onChange={handleChange}
                                                                                onSelect={handleSelect}
                                                                                searchOptions={{
                                                                                componentRestrictions: { country: convertToLowerCase(countryNumberCode) }
                                                                                }}
                                                                            >
                                                                                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                                                <>
                                                                                    
                                                                                    <textarea placeholder=""  onInput={handlesize}    className="form-control"  {...register("address", getValidationRules('address'))} {...getInputProps({
                                                                                        })}
                                                                                         />
                                                                                        <label for="">Address</label>
                                                                                    {errors.address && (
                                                                                    <span className="error">
                                                                                        {errors.address.message}
                                                                                    </span>
                                                                                    )}
                                                                                    
                                                                                    <div className="autocomplete-dropdown-container">
                                                                                    {loading && <div className="suggestion-item-active">Loading...</div>}
                                                                                    {suggestions.map((suggestion) => {
                                                                                        const className = suggestion.active
                                                                                        ? "suggestion-item-active"
                                                                                        : "suggestion-item";
                                                                                        // inline style for demonstration purpose
                                                                                        const style = suggestion.active
                                                                                        ? { cursor: "pointer" }
                                                                                        : { cursor: "pointer" };
                                                                                        return (
                                                                                        <div
                                                                                            {...getSuggestionItemProps(suggestion, {
                                                                                            className,
                                                                                            style,
                                                                                            })}
                                                                                        >
                                                                                            <span>{suggestion.description}</span>
                                                                                        </div>
                                                                                        );
                                                                                    })}
                                                                                    </div>
                                                                                </>
                                                                                )}
                                                                                
                                                                            </PlacesAutocomplete>
                                                                                {/* <textarea  className="form-control" placeholder="" {...register("address", getValidationRules('address'))} />
                                                                                <label for="">Address</label>
                                                                                {errors.address && (
                                                                                    <span className="error">
                                                                                        {errors.address.message}
                                                                                    </span>
                                                                                )} */}
                                                                            </div>


                                                                          
                                                                        
                                                                            <div className="deets-form">
                                                                                <div className="row">
                                                                                    <div className="col-md-4 mb-1">
                                                                                        <div className="form-group floating-label mt-2 mb-2">
                                                                                            <input type="text" className="form-control" placeholder=""{...register("city", getValidationRules('city'))} />
                                                                                            <label for="">City</label>
                                                                                            {errors.city && (
                                                                                            <span className="error">
                                                                                                {errors.city.message}
                                                                                            </span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-md-4 mb-1">
                                                                                        {(country != 'US' && country != 'IN') && <div className="form-group floating-label mb-2">
                                                                                        <input type="text" className="form-control" placeholder="" {...register("state", {
                                                                                            required: "Please enter state",
                                                                                        })} />
                                                                                        <label for="">State</label>
                                                                                        {errors.state && (
                                                                                            <span className="error">
                                                                                                {errors.state.message}
                                                                                            </span>
                                                                                        )}
                                                                                        </div>}


                                                                                        {country == 'US' && <div className="form-group mb-2">
                                                                                        <label for="" className="form-label primary_label m-0">State</label>
                                                                                        <select className="form-select" {...register("state_id", {
                                                                                            required: "Please select  state",
                                                                                        })}>
                                                                                            <option value="">Select State</option>
                                                                                            {(state || []).map((option) => (
                                                                                                <option key={option.value} value={option.value}>
                                                                                                    {option.name}
                                                                                                </option>
                                                                                            ))}
                                                                                        </select>
                                                                                        {errors.state_id && (
                                                                                            <span className="error">
                                                                                                {errors.state_id.message}
                                                                                            </span>
                                                                                        )}
                                                                                        </div>}



                                                                                        {country == 'IN' && <div className="form-group mb-2">
                                                                                            <label for=""   className="form-label primary_label m-0">State</label>
                                                                                                <select  className={`form-select grayout ${!watch("state_id") ? "gray" : ""}`} {...register("state_id", getValidationRules('state_id'))}>
                                                                                                    <option value="">Select State</option>
                                                                                                    {(inState || []).map((option) => (
                                                                                                    <option key={option.value} value={option.value}>
                                                                                                    {option.name}
                                                                                                    </option>
                                                                                                ))}
                                                                                                </select>
                                                                                                {errors.state_id && (
                                                                                                    <span className="error">
                                                                                                    {errors.state_id.message}
                                                                                                    </span>
                                                                                                )}
                                                                                            </div>}
                                                                                    </div>

                                                                                    <div className="col-md-4 mb-1">
                                                                                        <div className="form-group floating-label mb-2">
                                                                                            <input type="text" className="form-control" placeholder=""{...register("zip", getZipValidation())} />
                                                                                            <label for="">Zip</label>
                                                                                            {errors.zip && (
                                                                                                <span className="error">
                                                                                                    {errors.zip.message}
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-md-6 mt-1">
                                                                                        <div className="form-group">
                                                                                            <label for="" className="form-label primary_label">Currency</label>
                                                                                            <select className={`form-select ${!watch("currency_id") ? "gray" : ""}`} {...register("currency_id", getValidationRules("currency_id"))}
                                                                                            defaultValue={options?.find((option) => option.is_selected === 1)?.value || ""}>
                                                                                                <option value="" className="placeholder-test" disabled selected>Currency</option>
                                                                                                {(options || []).map((option) => (
                                                                                                    <option key={option.value} value={option.value}>
                                                                                                        {option.name}
                                                                                                    </option>
                                                                                                ))}
                                                                                            </select>
                                                                                            {errors.currency_id && (
                                                                                                <span className="error">
                                                                                                    {errors.currency_id.message}
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-md-6 mt-1">
                                                                                        <div className="form-group">
                                                                                            <label for="" className="form-label primary_label">Tax Type</label>
                                                                                            <select className={`form-select ${!watch("tax_type") ? "gray" : ""}`}  {...register("tax_type", getValidationRules("tax_type"))}
                                                                                            defaultValue={taxData?.find((option) => option.is_selected === 1)?.value || ""}>
                                                                                                <option value="">Tax Type</option>
                                                                                                {(taxData || []).map((option) => (
                                                                                                    <option key={option.value} value={option.value}>
                                                                                                        {option.name}
                                                                                                    </option>
                                                                                                ))}
                                                                                            </select>
                                                                                            {errors.tax_type && (
                                                                                                <span className="error">
                                                                                                    {errors.tax_type.message}
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>




                                                                          




                                                                           

                                                                            <div className="form-group">
                                                                                
                                                                                <label htmlFor="" className="form-label primary">
                                                                                Organization Logo
                                                                                </label>
                                                                                
                                                                                {hasImage == "1" ? (
                                                                                    <div className="services-imgs modal-category-img">
                                                                                    <img className="" src={imgPath} />
                                                                                    {hasImage =="1" &&
                                                                                        <a href="javascript:void(0)" className="close-btn">
                                                                                        <i
                                                                                            className="fa-regular fa-circle-xmark"
                                                                                            onClick={removeImg}
                                                                                        ></i>
                                                                                        </a>
                                                                                    }
                                                                                    </div>
                                                                                ) : (
                                                                                    <a
                                                                                    href="javascript:void(0)"
                                                                                    className="upload-img-sec w-100"
                                                                                    onClick={openFile}
                                                                                    >
                                                                                    <div className="upload-img">
                                                                                        <input
                                                                                        style={{ display: "none" }}
                                                                                        ref={addImageRef}
                                                                                        type="file"
                                                                                        accept="image/jpeg, image/png, image/jpg"
                                                                                        onChange={handleImgUpload}
                                                                                        />
                                                                                        <img src={addImg} />
                                                                                        <h6 className="mt-3 mb-0"></h6>
                                                                                        <span className="small gray"></span>
                                                                                    </div>
                                                                                    {/* {showAddIcon && (
                                                                                        <>
                                                                                        {hasImage == "1" ? (
                                                                                            <a
                                                                                            className="btn btn-primary w-100 mt-2"
                                                                                            onClick={removeImg}
                                                                                            >
                                                                                            <span className="material-symbols-outlined">delete</span>
                                                                                            </a>
                                                                                        ) : (
                                                                                            <></>
                                                                                        )}
                                                                                        </>
                                                                                    )} */}
                                                                                    </a>
                                                                                )}
                                                                                <Controller
                                                                                    name="org_image"
                                                                                    control={control}
                                                                                    defaultValue=""
                                                                                    
                                                                                    render={({ field }) => (
                                                                                        <input {...field} style={{ display: "none" }} type="text" value={hasImage} className="form-control"   placeholder=" "
                                                                                        />
                                                                                    )}
                                                                                    />
                                                                                    
                                                                                </div>
                                                                            {/* <select className="form-select" {...register("preferred_country ", {
                                                                                        required: "Please select country",
                                                                                    })} onChange={handleCountryChange}>
                                                                                <option value="" disabled>select prefered country</option>
                                                                                {(countryList || []).map((option) => (
                                                                                <option key={option.value} value={option.value}>
                                                                                    {option.name}
                                                                                </option>
                                                                                ))}
                                                                                
                                                                                </select> */}

                                                            <ModalBox
                                                                isShow={imageModalShow}
                                                                className="close-btn "
                                                                modalSize="md"
                                                                handleClose={handleClose}
                                                                hasData={true}
                                                            >
                                                                <ImageCropper
                                                                file={image}
                                                                onCropped={croppedImage}
                                                                aspectRatio={1/1}
                                                                type="organization"
                                                                orgKey=""
                                                                setKey={setTempKey}
                                                                />


                                                            </ModalBox>

                                                                        </div>

                                                                        {isProfile == 'organization' && <button type="submit" className="btn btn-primary w-100 mt-3">Next</button>}
                                                                    </form>
                                                                    <form onSubmit={handleSubmit1(razorPaySubmit)} style={{ display: isProfile == 'business' ? 'block' : 'none' }}>
                                                                        <div className="row">
                                                                            <div className="col-12">
                                                                                <div className="row">
                                                                                    <div className="col-lg-6">
                                                                                        <div class="form-group floating-label input-align">
                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control"
                                                                                                placeholder=""
                                                                                                {...registerForm1("business_name", {
                                                                                                    required: "Please enter business name",
                                                                                                    minLength: {
                                                                                                        value: 3,
                                                                                                        message: "Business name must be at least 3 characters"
                                                                                                    }
                                                                                                })}
                                                                                            />
                                                                                            <label for="">Legal Business Name</label>
                                                                                            {errorsForm1.business_name && (
                                                                                                <span className="error">
                                                                                                    {errorsForm1.business_name.message}
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-lg-6">
                                                                                        <div class="form-group floating-select mt-4">
                                                                                            <label for="" className="form-label primary_label">Select business type</label>
                                                                                            <select className="form-select" {...registerForm1("business_type", {
                                                                                                required: "Please select business type",
                                                                                            })}>
                                                                                                <option value="">Select Type</option>
                                                                                                {(BusinessList || []).map((option) => (
                                                                                                    <option key={option.value} value={option.value}>
                                                                                                        {option.name}
                                                                                                    </option>
                                                                                                ))}

                                                                                            </select>
                                                                                            {errorsForm1.business_type && (
                                                                                                <span className="error">
                                                                                                    {errorsForm1.business_type.message}
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-lg-6">
                                                                                        <div class="form-group floating-select mt-4">
                                                                                            <label for="" className="form-label primary_label">Select Category</label>
                                                                                            <select className="form-select" {...registerForm1("category_id", {
                                                                                                required: "Please select category",
                                                                                            })}>
                                                                                                <option value="" >Select Category</option>
                                                                                                {(categoryList || []).map((option) => (
                                                                                                    <option key={option.value} value={option.value} id={option.id} >
                                                                                                        {option.name}
                                                                                                    </option>
                                                                                                ))}
                                                                                            </select>
                                                                                            {errorsForm1.category_id && (
                                                                                                <span className="error">
                                                                                                    {errorsForm1.category_id.message}
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-lg-6">
                                                                                        <div class="form-group floating-select mt-4">
                                                                                            <label for="" className="form-label primary_label">Select Sub Category</label>
                                                                                            <select className="form-select" {...registerForm1("sub_category_id", {
                                                                                                required: "Please select sub category",
                                                                                            })}>
                                                                                                <option value="">Select sub category</option>
                                                                                                {(subCategoryList || []).map((option) => (
                                                                                                    <option key={option.value} value={option.value}>
                                                                                                        {option.name}
                                                                                                    </option>
                                                                                                ))}
                                                                                            </select>
                                                                                            {errorsForm1.sub_category_id && (
                                                                                                <span className="error">
                                                                                                    {errorsForm1.sub_category_id.message}
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-12">
                                                                                <div className="row">
                                                                                    <div className="col-lg-6">
                                                                                        <div class="form-group floating-label mt-4">
                                                                                            <input type="text" class="form-control" placeholder=""
                                                                                                {...registerForm1("stakeholder_name", {
                                                                                                    required: "Please enter stake holder name",
                                                                                                })} />
                                                                                            <label for="">Stakeholder Name</label>
                                                                                            {errorsForm1.stakeholder_name && (
                                                                                                <span className="error">
                                                                                                    {errorsForm1.stakeholder_name.message}
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-lg-6">
                                                                                        <div class="form-group floating-label mt-4">
                                                                                            <input type="text" class="form-control" placeholder=""
                                                                                                {...registerForm1("stakeholder_email", {
                                                                                                    required: "Please enter stakeholder email",
                                                                                                    pattern: {
                                                                                                        value: emailRegEx,
                                                                                                        message: "Please enter a valid email address",
                                                                                                    },
                                                                                                })} />
                                                                                            <label for="">Stakeholder Email</label>
                                                                                            {errorsForm1.stakeholder_email && (
                                                                                                <span className="error">
                                                                                                    {errorsForm1.stakeholder_email.message}
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <div className="col-12">
                                                                                <div className="row">
                                                                                    <div className="col-lg-6">
                                                                                        <div class="form-group floating-label mt-4">
                                                                                            <input type="text" class="form-control" placeholder=""
                                                                                                {...registerForm1("account_number", {
                                                                                                    required: "Please enter account number",
                                                                                                    pattern: {
                                                                                                        value: bankAccountRegex,
                                                                                                        message: "Please enter a valid account number",
                                                                                                    },
                                                                                                })} />
                                                                                            <label for="">Account Number</label>
                                                                                            {errorsForm1.account_number && (
                                                                                                <span className="error">
                                                                                                    {errorsForm1.account_number.message}
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-lg-6">
                                                                                        <div class="form-group floating-label mt-4">
                                                                                            <input type="text" class="form-control" placeholder=""
                                                                                                {...registerForm1("ifsc_code", {
                                                                                                    required: "Please enter ifsc code",
                                                                                                })} />
                                                                                            <label for="">IFSC Code</label>
                                                                                            {errorsForm1.ifsc_code && (
                                                                                                <span className="error">
                                                                                                    {errorsForm1.ifsc_code.message}
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="col-12">
                                                                                        <div class="form-group floating-label mt-4">
                                                                                            <input type="text" class="form-control" placeholder=""
                                                                                                {...registerForm1("benificiary_name", {
                                                                                                    required: "Please enter beneficiary name",
                                                                                                })} />
                                                                                            <label for="">Beneficiary Name</label>
                                                                                            {errorsForm1.benificiary_name && (
                                                                                                <span className="error">
                                                                                                    {errorsForm1.benificiary_name.message}
                                                                                                </span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>



                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <button type="submit" class="btn btn-primary w-100 mt-3">Submit</button>
                                                                    </form>

                                                                </div>
                                                            </div>
                                                            <ModalBox
                                                                isShow={showLoader}
                                                                className="close-btn "
                                                                modalSize="md"
                                                                hasData={true}
                                                            >
                                                                <div className='download-sec'>
                                                                    <div>
                                                                        <img className="" src={loaderFile} alt="Loading..." />
                                                                        <h5 className='mt-4 gray'></h5>
                                                                    </div>
                                                                </div>


                                                            </ModalBox>
                                                        </>
                                                    );
                                                case "stripe":
                                                    return (
                                                        <>
                                                            <div className="login-form">
                                                                <div className="loginText text-center">
                                                                    <h1>{stripedata?.tittleLabel}</h1>
                                                                    <p className="login m-0">{stripedata?.stripe_info_text}</p>
                                                                    <img src={stripeicon} className="img-fluid" />
                                                                    <p className="stripe-info mb-5  txt-sty" >{stripedata?.stripe_info_description}</p>
                                                                    <a href={url} className="btn btn-primary w-100">Continue</a>
                                                                    {/* <p className="mt-4">By continuing, You agree to the <a href={`${baseUrl}terms`} target="_blank">terms & conditions</a> and <a href={`${baseUrl}privacypolicy`} target="_blank"><span className="noBreak">privacy policies</span></a></p> */}
                                                                </div>
                                                            </div>

                                                        </>
                                                    );
                                                case "razorPay":
                                                    return (
                                                        <>
                                                            <div className="login-form">
                                                                <div className="loginText text-center">
                                                                    <h1>{stripedata?.tittleLabel}</h1>
                                                                    <p className="login m-0">{stripedata?.text}</p>
                                                                    <img src={razoricon} className="img-fluid" />
                                                                    <p className="stripe-info mb-5 txt-sty">{stripedata?.description}</p>
                                                                    <button onClick={() => { setIsProfile('business'); setRegister('register'); }} className="btn btn-primary w-100">Continue</button>
                                                                    {/* <p className="mt-4">By continuing, You agree to the <a href={`${baseUrl}terms`} target="_blank">terms & conditions</a> and <a href={`${baseUrl}privacypolicy`} target="_blank"><span className="noBreak">privacy policies</span></a></p> */}
                                                                </div>
                                                            </div>

                                                        </>
                                                    );
                                                default:
                                                    return (
                                                        <>
                                                            <div className="login-form">
                                                                <div className="loginText text-center">
                                                                    <h1>Sign In</h1>
                                                                    <p className="login m-0">Optimize business operations with us.</p>
                                                                </div>
                                                                <div className="loginInner text-center">
                                                                    {/* <a href="" className="btn btn-outline-secondary w-100"><img src={googleicon} className="img-fluid" />Sign in with google</a>
                                                                    <div className="orSection">
                                                                        <span></span><p className="m-0">or</p><span></span>
                                                                    </div> */}
                                                                    <form onSubmit={handleSubmit(sentOtp)} onKeyDown={(e) => {
                                                                          if (e.key === "Enter") {
                                                                                e.preventDefault(); 
                                                                                handleSubmit(sentOtp)(); 
                                                                            }
                                                                        }}>
                                                                        <div className="form-group selectBlocker flex-column  mt-4">
                                                                            <Controller
                                                                                name="phone_number"
                                                                                control={control}
                                                                                defaultValue=""
                                                                                rules={{
                                                                                    required: 'Please enter phone number',
                                                                                    validate: (value) => {
                                                                                        const phoneNumber = value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                                                                                        return phoneNumber.length > 4 || 'Please enter a valid phone number';
                                                                                    }
                                                                                }}
                                                                                render={({ field: { onChange, value, ref, onBlur } }) => (
                                                                                    <PhoneInput
                                                                                        country={'us'}
                                                                                        onlyCountries={['us', 'gb']} 
                                                                                        value={value}
                                                                                        onChange={(value, countryData) => {
                                                                                            onChange(value);  // Update react-hook-form state
                                                                                            const phoneNumberWithoutCountryCode = value.startsWith(countryData.dialCode)
                                                                                                ? value.substring(countryData.dialCode.length)
                                                                                                : value.replace(`+${countryData.dialCode}`, '');
                                                                                            setPhoneNumber(phoneNumberWithoutCountryCode.trim());
                                                                                            setCode(`+${countryData.dialCode}`);
                                                                                            setShortCode(countryData.countryCode.toUpperCase());
                                                                                            setCountry(countryData.countryCode.toUpperCase());
                                                                                        }}
                                                                                        onBlur={() => {
                                                                                            setValue('phone_number', value, { shouldValidate: true });
                                                                                            onBlur();  // Trigger validation on blur (when the user leaves the field)
                                                                                        }}
                                                                                        enableSearch={true}
                                                                                        countryCodeEditable={false}
                                                                                        searchPlaceholder="Search"
                                                                                        containerClass="phone-code-form"
                                                                                        specialLabel="Phone Number"
                                                                                        inputRef={ref}  // Attach ref to the input
                                                                                    />
                                                                                )}
                                                                            />
                                                                            {errors.phone_number && (
                                                                                <span className="error">
                                                                                    {errors.phone_number.message}
                                                                                </span>
                                                                            )}

                                                                        </div>


                                                                        <button type="submit" className="btn btn-primary w-100" disabled={isContinueDisabled}>Get OTP</button>
                                                                        <p className="mt-4">By continuing, I agree to the <a href={`${swizzleUrl}termsandconditions`} target="_blank">Terms & Conditions</a> and <a href={`${swizzleUrl}privacypolicy`} target="_blank"><span className="noBreak">Privacy Policy</span></a></p>

                                                                    </form>

                                                                </div>
                                                            </div>
                                                        </>
                                                    );
                                            }


                                        })()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>

    )
}

export default Login